.section {
  display: flex;
  align-items: center;
}
.sectionV2 {
  align-items: center;
}

.label {
  margin-left: 8px;
}

.date {
  white-space: nowrap;
}
